// Image URL helpers: request appropriately-sized renditions instead of the
// raw upload. Falls back to the original URL for hosts we don't know.

const SUPABASE_PUBLIC_PATH = '/storage/v1/object/public/';
const SUPABASE_RENDER_PATH = '/storage/v1/render/image/public/';

/**
 * A resized/compressed rendition of a stored image.
 * - Supabase Storage: uses the image render endpoint (on-the-fly transform).
 * - Shopify CDN: uses its native width param.
 * - Anything else: returned untouched.
 */
export function thumbUrl(url: string | undefined | null, width = 600): string | undefined {
  if (!url) return undefined;
  try {
    if (url.includes(SUPABASE_PUBLIC_PATH)) {
      const sep = url.includes('?') ? '&' : '?';
      return `${url.replace(SUPABASE_PUBLIC_PATH, SUPABASE_RENDER_PATH)}${sep}width=${width}&quality=75`;
    }
    if (url.includes('cdn.shopify.com')) {
      const sep = url.includes('?') ? '&' : '?';
      return `${url}${sep}width=${width}`;
    }
  } catch {
    // fall through to original
  }
  return url;
}

/** Social-card rendition (Facebook/Twitter want ~1200x630). */
export function socialImageUrl(url: string | undefined | null): string | undefined {
  return thumbUrl(url, 1200);
}
